import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;

  padding: 10rem 0;
`;

export const Header = styled.header`
  display: flex;
  align-items: center;

  height: 10rem;
  width: 100%;

  position: fixed;
  top: 0;

  .logo-container {
    display: flex;
    align-items: center;
    justify-content: center;

    background: #242424;

    height: 100%;
    width: 10rem;
  }

  > nav {
    display: flex;
    align-items: center;

    background: #ffdf22;
    flex: 1;
    height: 100%;

    padding: 3rem 2rem;

    @media (min-width: 768px) {
      padding: 3rem 5.6rem;
    }

    > h1 {
      font-weight: ${({ theme }) => theme.fontWeight.LatoBold};
      font-size: 2.4rem;
      letter-spacing: 1.6px;
      text-transform: uppercase;
      color: ${({ theme }) => theme.colors.black};

      @media (min-width: 425px) {
        font-size: 3.2rem;
      }
    }
  }
`;

export const ButtonBack = styled.button`
  display: flex;
  align-items: center;

  background: none;

  margin: 2rem;

  > h2 {
    font-size: 2.4rem;
    letter-spacing: 1.25px;
    text-transform: uppercase;
  }

  @media (min-width: 768px) {
    margin: 3.7rem 10.2rem 2.5rem;
  }
`;

export const Content = styled.main`
  background: ${({ theme }) => theme.colors.white};

  padding: 0 2rem;
  flex: 1;

  @media (min-width: 768px) {
    padding: 0rem 10.2rem;
  }

  > p {
    margin: 1rem 0;
    color: #43434a;
    text-align: justify;
  }
`;
